
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16.21 7.807l-6.165 6.164L8.075 12a1.045 1.045 0 00-1.479 1.478l2.715 2.715c.41.41 1.07.41 1.479 0l6.908-6.908a1.044 1.044 0 000-1.478 1.057 1.057 0 00-1.489 0z"}})])
          )
        }
      }
    